import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';
const DailyTxBulletin = lazy(
  () => import('../DailyTxBulletin/DailyTxBulletin')
);

const TransactionsMain = lazy(() => import('../tx/TransactionsMain'));
const InjuredInactiveRehab = lazy(
  () => import('../tx/InjuredInactiveRehab/InjuredInactiveRehab')
);
const TaxiSquad = lazy(() => import('../tx/TaxiSquad/TaxiSquad'));
const PlayerTracking = lazy(
  () => import('../tx/PlayerTracking/PlayerTracking')
);
const PiefList = lazy(() => import('../pief/PiefList'));
const PiefListForm = lazy(() => import('../pief/PiefListForm/PiefListForm'));
const RecertificationForm = lazy(
  () => import('../tx/Recertification/RecertificationForm')
);
const ElectedFreeAgency = lazy(
  () => import('../elected-free-agency/ElectedFreeAgency')
);
const PaymentsForm = lazy(() => import('../tx/Payments/PaymentsForm'));
export default [
  {
    id: NavConfig.groupConfigs.TRANSACTIONS.id,
    path: NavConfig.groupConfigs.TRANSACTIONS.to,
    element: (
      <TransactionsMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </TransactionsMain>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate to={NavConfig.linkConfigs.TX_INJURED_INACTIVE_REHAB.to} />
        ),
      },
      {
        id: NavConfig.linkConfigs.TX_DAILY_TRANS_BULLETIN.id,
        path: NavConfig.linkConfigs.TX_DAILY_TRANS_BULLETIN.to,
        element: <DailyTxBulletin />,
      },
      {
        id: NavConfig.linkConfigs.TX_INJURED_INACTIVE_REHAB.id,
        path: NavConfig.linkConfigs.TX_INJURED_INACTIVE_REHAB.to,
        element: <InjuredInactiveRehab />,
      },
      {
        id: NavConfig.linkConfigs.TX_TAXI_SQUAD.id,
        path: NavConfig.linkConfigs.TX_TAXI_SQUAD.to,
        element: <TaxiSquad />,
      },
      {
        id: NavConfig.linkConfigs.TX_PLAYER_TRACKING.id,
        path: NavConfig.linkConfigs.TX_PLAYER_TRACKING.to,
        element: <PlayerTracking />,
      },
      {
        id: NavConfig.linkConfigs.TX_PIEF_LIST.id,
        path: NavConfig.linkConfigs.TX_PIEF_LIST.to,
        element: <PiefList />,
      },
      {
        id: NavConfig.linkConfigs.TX_PIEF_LIST_FORM.id,
        path: NavConfig.linkConfigs.TX_PIEF_LIST_FORM.to,
        element: <PiefListForm />,
      },
      {
        id: NavConfig.linkConfigs.TX_IL_RECERTIFICATION.id,
        path: NavConfig.linkConfigs.TX_IL_RECERTIFICATION.to,
        element: <RecertificationForm />,
      },
      {
        id: NavConfig.linkConfigs.TX_ELECT_FREE_AGENCY_XX_B_.id,
        path: NavConfig.linkConfigs.TX_ELECT_FREE_AGENCY_XX_B_.to,
        element: <ElectedFreeAgency />,
      },
      {
        id: NavConfig.linkConfigs.TX_TRANSACTION_PAYMENTS.id,
        path: NavConfig.linkConfigs.TX_TRANSACTION_PAYMENTS.to,
        element: <PaymentsForm />,
      },
    ],
  },
];
